import { createFileRoute } from "@tanstack/react-router";

import { PriceSettingsPage } from "@/features/settings/price/price-settings-page";

export const Route = createFileRoute("/settings/price")({
  component: PriceSettingsPage,
});
